import type { ReactElement } from 'react';
import { Routes, Route } from 'react-router-dom';
import { LoginPage, AuthGuard } from '@/features/auth';
import { AppLayout } from '@/components/layout';
import {
  DashboardPageWrapper,
  SuperAdminRoutes,
  CompanyRoutes,
  AgentRoutes,
  CandidatePublicRoutes,
  CandidateAuthenticatedRoutes,
  RefereePublicRoutes,
  CertificatePublicRoutes,
} from './routes';
import { PrivacyPolicyPage } from '@/features/privacy';

function UnauthorizedPage(): ReactElement {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <h1 className="text-2xl font-bold text-red-500">Unauthorized</h1>
    </div>
  );
}

export function AppRouter(): ReactElement {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/unauthorized" element={<UnauthorizedPage />} />

      {/* Public privacy notice - no auth required */}
      <Route path="/privacy" element={<PrivacyPolicyPage />} />

      {/* Public candidate routes - no auth required */}
      {CandidatePublicRoutes()}

      {/* Public referee routes - no auth required */}
      {RefereePublicRoutes()}

      {/* Public candidate certificate - no auth required */}
      {CertificatePublicRoutes()}

      {/* Authenticated candidate routes */}
      {CandidateAuthenticatedRoutes()}

      {/* Internal app routes */}
      <Route
        element={
          <AuthGuard>
            <AppLayout />
          </AuthGuard>
        }
      >
        <Route path="/" element={<DashboardPageWrapper />} />
        {SuperAdminRoutes()}
        {CompanyRoutes()}
        {AgentRoutes()}
      </Route>
    </Routes>
  );
}
